import { createTheme } from "@mui/material/styles";
import { themeColors } from "./colors";
import { defaultTheme } from "./default";

// Export the new enhanced default theme
export { defaultTheme, themeColors };

// Maintain backward compatibility with existing darkTheme and lightTheme exports
export const darkTheme = defaultTheme;

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});
